import { CircularProgress } from '@mui/material';
import MeetingDataTable from 'app/components/DataTable/meeting/MeetingDataTable';
import { getMeetingListFromAuthUserIdApi } from 'api/meeting';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setAllReadMeetingList, setPageType } from 'stores/meeting';
import LoadingPopUp from 'app/components/LoadingPopup';

// tam okuma listesi 368,371
const ListMeeting = () => {

    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const allReadMeetingList = useSelector((state) => state.meeting.allReadMeetingList);
    const { pageType } = useParams(); // subType=undefined ise sol menüden geliyor dolu ise dashboarddan


    useEffect(() => {
        const getAPI = async () => {
            setLoading(true);
            try {

                dispatch(setPageType(pageType))
                if (!(allReadMeetingList !== undefined && allReadMeetingList.length > 0)) {
                    let res = await getMeetingListFromAuthUserIdApi("read"); // yetkili olduğu meetingler
                    let allList = res.data;
                    dispatch(setAllReadMeetingList(allList));

                    if (pageType !== undefined && pageType === "2") { // YK okuma
                        allList = allList.filter(x => x.inst === "YK");


                    } else if (pageType !== undefined && pageType === "4") { // kurul okuma
                        allList = allList.filter(x => x.inst !== "YK");

                    }

                }

            } catch (error) {
                console.error("API Hatası: ", error);
            } finally {
                setLoading(false);
            }
        };

        getAPI();
    }, [pageType]);




    const columnData = [
        { id: 'id', align: 'left', disablePadding: false, label: "ID" },
        { id: 'inst', align: 'left', disablePadding: false, label: "Kurum" },
        { id: 'unit', align: 'left', disablePadding: true, label: "Kurul/Kol/Komisyon" },
        { id: 'meetingNo', align: 'left', disablePadding: false, label: "Toplantı No" },
        { id: 'pdate', align: 'left', disablePadding: true, label: "Tarih" },
        { id: 'adminUserId', align: 'center', disablePadding: false, label: "Toplantı Yöneticisi" },
        { id: 'decisionCount', align: 'left', disablePadding: true, label: "Karar Sayısı" },
        { id: 'userList', align: 'left', disablePadding: true, label: "Üyeler" },
        { id: 'participantList', align: 'left', disablePadding: true, label: "Katılımcılar" },
        { id: 'islemler', align: 'center', disablePadding: false, label: "İşlemler" },
        { id: 'islemler', align: 'center', disablePadding: false, label: "" }
    ];

    return (
        <React.Fragment>

            <>
                <LoadingPopUp open={loading} />
                {!loading && <MeetingDataTable column={columnData} pageTitle="Toplantı Listesi (Okuma)" />}
            </>


        </React.Fragment>
    );
};

export default ListMeeting;